import { QueryClient } from '@tanstack/react-query';
import { API_AUTH_REQUIRED_EVENT, API_CONFIG_CHANGED_EVENT } from './config';

/**
 * Single app-wide TanStack Query client for read paths.
 *
 * Reads route through `api/client.ts` (never `fetch` directly), so the
 * centralized 401 → `clearRuntimeApiToken()` → `API_AUTH_REQUIRED_EVENT`
 * behavior still fires. Billable mutation flows (purchase/cancel/bulk) are
 * intentionally NOT managed here — they keep their hand-rolled, fail-closed
 * logic.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// When the operator swaps Worker URL / token, drop every cached response so a
// different Worker's data is never served from cache (mirrors the per-page
// api-identity scoping the pages used before).
if (typeof window !== 'undefined') {
  window.addEventListener(API_CONFIG_CHANGED_EVENT, () => {
    queryClient.clear();
  });
  // Sign-out / auth expiry (401 → clearRuntimeApiToken → triggerAuthExpired)
  // must also drop the cache, so whoever signs in next in this tab never sees
  // the previous user's data.
  window.addEventListener(API_AUTH_REQUIRED_EVENT, () => {
    queryClient.clear();
  });
}
